import { AlignHorizontalCenterIcon } from './AlignHorizontalCenterIcon';

/**
 * author: Google
 * id 05901A9E-71D5-47D9-B5E1-DC55B687E8E0
 * name align-horizontal-center
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-horizontal-center.svg
 * tags
 */
export const AlignHorizontalCentreIcon = AlignHorizontalCenterIcon;
export default AlignHorizontalCentreIcon